import { computed, signal } from '@preact/signals';

// Hash routes, so a reload (or a ⚑ report) keeps the place. A fuller router arrives in M4/M5.
//   ''               → Home
//   '#/map/<id>'     → map viewer for a level (dev menu in M1; Planning later)
export type Route = { screen: 'home' } | { screen: 'map'; levelId: string };
export type ScreenId = Route['screen'];

export function parseRoute(hash: string): Route {
  const m = /^#\/map\/([a-z0-9-]+)$/.exec(hash);
  if (m) return { screen: 'map', levelId: m[1] as string };
  return { screen: 'home' };
}

export function routeHash(r: Route): string {
  return r.screen === 'map' ? `#/map/${r.levelId}` : '';
}

export const route = signal<Route>(
  typeof location === 'undefined' ? { screen: 'home' } : parseRoute(location.hash),
);
export const currentScreen = computed<ScreenId>(() => route.value.screen);

export function navigate(r: Route): void {
  const hash = routeHash(r);
  if (hash === '') history.pushState(null, '', location.pathname + location.search);
  else location.hash = hash;
  route.value = r;
}

export function watchRoute(): void {
  const sync = (): void => {
    route.value = parseRoute(location.hash);
  };
  window.addEventListener('hashchange', sync);
  window.addEventListener('popstate', sync);
}
